import { render, staticRenderFns } from "./LgFinderPageAutorizacoes.vue?vue&type=template&id=5fe64a15"
import script from "./LgFinderPageAutorizacoes.vue?vue&type=script&lang=js"
export * from "./LgFinderPageAutorizacoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports